import {GetUserRejectedListUrl,deleteRejectedUserUrl,ApproveRejectedUserUrl,GetRegionListUrl } from '../../../Comman/apiEndPoints';
import varAxios from "../../../Comman/axios";

export const Fetch_User_Rejected_List = "Fetch_User_Rejected_List";
export const Update_Request = "Update_Request";
export const Update_Delete_Response = "Update_Delete_Response";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export function getUserRejectedList(RegionId,dispatch) {
    return(dispatch) =>{
       return varAxios.post(GetUserRejectedListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
          dispatch(
            fetchUserRejectedList({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              rejectedList : response.data.UserRejectedList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
/* export function getUserRejectedList() {
    return(dispatch) =>{
       return varAxios.get(GetUserRejectedListUrl)
       .then(response => {
          dispatch(
            fetchUserRejectedList({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              rejectedList : response.data.UserRejectedList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
} */
export function fetchUserRejectedList({errorCode,statusCode,rejectedList}) {
    return {
      type : Fetch_User_Rejected_List,
      errorCode,
      statusCode,
      rejectedList
    }
}
export function deleteRejectedUser(requestPayload,Region) {
  return (dispatch) => {
      dispatch(updateRequest());

      return varAxios.delete(deleteRejectedUserUrl,{data:requestPayload} ,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                updateResponse(response.data.Message,response.data.List,
                  response.data.errorCode,response.data.statusCode)
              );
              this.getUserRejectedList({RegionId:Region})
          })
          .catch((error) => {
              if(error.response.data.statusCode==401){
                alert(error.response.data.Message)
              }
          })
  }
}
export function updateRequest() {
    return {
      type : Update_Request
    }
}
export function updateResponse(message,updatedList,errorCode,statusCode) {
  return {
    type : Update_Delete_Response,
    message,
    updatedList,
    errorCode,
    statusCode
  }
}
export function approveFirstResponderUser(data,Region){
  return (dispatch) => {
    dispatch(updateRequest());
    return varAxios.post(ApproveRejectedUserUrl, data,
        JSON.stringify({
            derived: 'd',
            message: 'e'
        }))
        .then((response) => {
            
            dispatch(
              updateResponse(response.data.Message,response.data.RejectedList,
                response.data.errorCode,response.data.statusCode)
            );
            this.getUserRejectedList({RegionId:Region})
        })
        .catch((error) => {
          if(error.response.data.statusCode==401){
            alert(error.response.data.Message)
          }
        })
  }
}
export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getUserRejectedList({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}